import {
  Text,
  GreyGrey70,
  IndigoIndigo60,
  Link,
  Popover,
  Primary13Regular,
  Primary13SemiBold,
  Td,
  Tr,
  Box,
  Flex
} from '@sequencehq/core-components'
import { Customer } from 'modules/Customers/types'
import { CustomerPreviewCardPill } from '../CustomerPreviewCard'

export const CustomerRelationship = ({ customer }: { customer: Customer }) => {
  if (!customer?.organizations?.length) {
    return null
  }

  const isParentAccount = customer?.organizations.some(
    org => org.owner.id === customer.id && org?.members?.length !== 0
  )

  if (!isParentAccount) {
    const parentOrganization = customer.organizations.find(
      org => org.members.length > 0 && org.owner.id !== customer.id
    )

    if (!parentOrganization?.owner?.id) {
      return null
    }

    return (
      <>
        <Text {...Primary13Regular} color={GreyGrey70}>
          Parent customer
        </Text>
        <CustomerPreviewCardPill customerId={parentOrganization.owner.id} />
      </>
    )
  } else {
    const childAccountsCount = customer?.organizations.reduce((count, org) => {
      return count + org.members.length
    }, 0)

    if (childAccountsCount === 0) {
      return null
    } else {
      return (
        <>
          <Box mt="1">
            <Text {...Primary13Regular} color={GreyGrey70}>
              Child customers
            </Text>
          </Box>

          <Flex gap={2} overflow="hidden">
            <Popover
              position="right"
              header="Child customers"
              maxHeight="400px"
              maxWidth="400px"
              variant="table"
              closeOnBlur={false}
              offset={[75, 25]}
              content={customer.organizations.flatMap(org => {
                return org?.members.map(member => (
                  <Tr
                    key={member.id}
                    data-testid={`customer.childCustomers.row.${member.id}`}
                    sx={{
                      _hover: {
                        cursor: 'default!important',
                        bg: 'inherit!important'
                      }
                    }}
                  >
                    <Td
                      display={'flex'}
                      alignItems="center"
                      justifyContent="space-between"
                      gap="12px"
                    >
                      <Text
                        {...Primary13Regular}
                        color={GreyGrey70}
                        overflow="hidden"
                        textOverflow="ellipsis"
                        whiteSpace="nowrap"
                        minWidth={0}
                      >
                        {member.name}
                      </Text>
                      <Text
                        {...Primary13SemiBold}
                        color={IndigoIndigo60}
                        flexShrink={0}
                      >
                        <Link.Unstyled
                          data-testid={`customer.childCustomers.view.${member.id}`}
                          to={`/customers/${member.id}`}
                          onClick={e => e.stopPropagation()}
                        >
                          View
                        </Link.Unstyled>
                      </Text>
                    </Td>
                  </Tr>
                ))
              })}
            >
              <Text
                data-testid="customer.childCustomers.trigger"
                {...Primary13Regular}
                color={GreyGrey70}
                cursor="help"
                borderBottom={`1px dashed ${GreyGrey70}`}
                py="4px"
              >
                {`${childAccountsCount} ${
                  childAccountsCount > 1 ? 'customers' : 'customer'
                }`}
              </Text>
            </Popover>
          </Flex>
        </>
      )
    }
  }
}
